import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Projects from './components/Projects';
import CatalogPreview from './components/CatalogPreview';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    // Schema.org JSON-LD for homepage
    const schema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Zhongming Import SL",
      "alternateName": "Zhongming Import",
      "description": "Importación directa de materiales de construcción y decoración premium desde China a España. Soluciones B2B para arquitectos, interioristas y constructoras.",
      "url": import.meta.env.VITE_SITE_URL || "https://zhongmingimport.com",
      "logo": `${import.meta.env.VITE_SITE_URL || "https://zhongmingimport.com"}/logo.png`,
      "foundingDate": "2014",
      "legalName": "Zhongming Import SL",
      "taxID": "B75817635",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "C/ PICO DE LA CIERVA 1",
        "addressLocality": "Madrid",
        "postalCode": "28031",
        "addressRegion": "Madrid",
        "addressCountry": "ES"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+34-688-06-61-41",
        "contactType": "sales",
        "areaServed": "ES",
        "availableLanguage": ["es", "zh", "en"]
      },
      "sameAs": [
        "https://www.linkedin.com/company/zhongmingimport"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Materiales de Construcción Premium",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Revestimientos Cerámicos Premium",
              "category": "Materiales de Construcción"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Pavimentos Técnicos",
              "category": "Materiales de Construcción"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Sanitarios de Diseño",
              "category": "Materiales de Construcción"
            }
          }
        ]
      },
      "knowsAbout": [
        "Importación de materiales de construcción",
        "Control de calidad internacional",
        "Logística integral",
        "Certificación CE",
        "Comercio B2B China-España"
      ],
      "areaServed": {
        "@type": "Country",
        "name": "España"
      }
    };

    const schemaScript = document.getElementById('organization-schema');
    if (schemaScript) {
      schemaScript.textContent = JSON.stringify(schema);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <WhyChooseUs />
      <Projects />
      <CatalogPreview />
      <Contact />
      <Footer />
    </div>
  );
}
